import { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import gujaratiFont from './assets/NotoGujratiFont';

// @ts-ignore
import html2pdf from "html2pdf.js";
import { QRCodeCanvas } from "qrcode.react";
import { licenseQR } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";


const PanelLicenseDownload = ({application , partners , officeAddress}) => {
    const token = useSelector((state: any) => state.auth.token);
  

  const pdfRef = useRef<HTMLDivElement>(null);

  const [loading, setLoading] = useState(false);
  const education= application.eduQualification.map(data=> data.standard);
  const [qrUrl , setQrUrl] = useState();

  const educationMap: Record<string, string> = {
  highSchool: "High School",
  diploma: "Diploma",
  bachelorDegree: "Bachelor's Degree",
  mastersDegree: "Master's Degree",
  phd: "Ph.D.",
};


  const educat = education
  .map((key) => educationMap[key] || key) // fallback to original key if not found
  .join(", ");


const gujaratiHtmlContent = `


    <div class="header">
        <h2>સંચાલક, ખેડૂતોની બજારો અને ગ્રામિણ અર્થતંત્ર, ગુજરાત રાજ્ય, ગાંધીનગર</h2>
        <p>બ્લોક નં. ૧૩/૨, ડો. જીવરાજ મહેતા ભવન, ગાંધીનગર</p>
        <p>વેબસાઇટ: <a href="http://doamf.gujarat.gov.in">doamf.gujarat.gov.in</a> | ફોન: (079) 23254584</p>
    </div>

    <div class="content">
        <p><strong>ક્રમ નં.:</strong> નાબસ/૦૧/થ/ઓ.એસ./૨૦૨૫ &nbsp;&nbsp; <strong>તારીખ:</strong> </p>
        
        <h3>વાંચન લેવામાં આવ્યું:</h3>
        <ul>
            <li>ગુજરાત કૃષિ ઉત્પન્ન બજાર નિયમો, 1965 ની નિયમ 44 ની જોગવાઈ</li>
            <li>આ કચેરીનો પરિપત્ર નં. તારીખ 10/03/2025 - NABS/01/TH/OS/117/2025</li>
            <li>ઉપસંચાલક અને જિલ્લા રજિસ્ટ્રાર સહકારી સંસ્થાઓ, ${application?.District} તારીખ...../...../20....</li>
            <li>પત્ર ક્રમાંક:- <span class="underline">${application?.licenseNo ? application?.licenseNo : ""}</span> તરફથી રજૂ કરાયેલ પ્રસ્તાવ</li>
        </ul>

        <h3>આદેશ:</h3>
        <p>પરિપ્રશિષ્ટ-3 માં દર્શાવેલા પત્રમાં પ્રસ્તાવોની ચકાસણી કર્યા પછી, નીચે જણાવેલ એન્જિનિયરને જેની લાયકાત અને અનુભવ નિયમો મુજબ છે, ____/_____/_____ થી 31/03/2025 સુધીની અવધિ માટે નિમવામાં આવે છે.</p>
    </div>

    <div class="table-container">
        <table>
            <tr>
                <th>અ.નં.</th>
                <th>પેનલ નંબર</th>
                <th>એન્જિનિયરની નામ</th>
                <th>સંપૂર્ણ સરનામું</th>
                <th>શૈક્ષણિક લાયકાત</th>
            </tr>
            ${
                partners?.length > 0
                    ? partners.map((partner, index) => `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${partner?.panelNumber || ""}</td>
                            <td>${partner?.engineerName || ""}</td>
                            <td>
                                ${partner?.address?.at || ""}, Taluka: ${partner?.address?.taluka || ""}, Dist: ${partner?.address?.district || ""}
                            </td>
                            <td>${partner?.educationQualification || ""}</td>
                        </tr>
                    `).join("")
                    : `<tr><td colspan="5" style="text-align: center;">કોઈ ડેટા ઉપલબ્ધ નથી</td></tr>`
            }
        </table>
    </div>

    <p><strong>સંચાલક</strong><br>
        ખેડૂતોની બજારો અને ગ્રામિણ અર્થતંત્ર<br>
        ગુજરાત રાજ્ય, ગાંધીનગર</p>

    <h3>માથી:</h3>
    <p>નામ: <span class="underline">${application?.applicantName ? application?.applicantName : "......................." }</span><br>
       સરનામું:<span class="underline">${officeAddress?.address ? officeAddress?.address: ".................."}     Taluka : ${officeAddress?.taluka ? officeAddress?.taluka: ".................."}         Dist. ${officeAddress?.district ? officeAddress?.district: ".................."}</span><br>
       મોબાઇલ નંબર:<span class="underline">${application?.mobileNo ? application?.mobileNo : "......................." }</span><br>
       ઈ-મેલ: <span class="underline">${application?.registeredEmail ? application?.registeredEmail : "......................." }</span></p>

    <h3>ની નકલ મોકલવામાં આવે:</h3>
    <ul>
        <li>ઉપસંચાલક, ખેડૂતોની બજાર અને જિલ્લા રજિસ્ટ્રાર સહકારી સંસ્થાઓ, મહિસાગર</li>
        <li>મેનેજિંગ ડાયરેક્ટર, ગુજરાત રાજ્ય કૃષિ બજાર બોર્ડ, ગાંધીનગર</li>
    </ul>

`;



const appliedDate =  (isoDate:any) => {
  
  const date = new Date(isoDate);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear(); 


  return `${day}/${month}/${year}`;
};

const fetchLicenseQr = async()=>{
  const body ={
    name: application?.applicantName,
    applicationId: application?.applicationId,
    email: application?.regEmailId,
    licenseNo: application?.licenseNo
  }
  try {
    const res = await licenseQR(body , token);
   
    setQrUrl(res.qrCode);
  } catch (error) {

  }
}

const handleDownloadPDF = async() => {
  // await fetchLicenseQr()
 
  if (!pdfRef.current) return;

  const clonedContent = pdfRef.current.cloneNode(true) as HTMLElement;
  clonedContent.style.display = "block"; // Ensure visibility for capture

  // ✅ Convert QR Code from Canvas to Image
  const qrCanvas = pdfRef.current.querySelector("canvas");
  if (qrCanvas) {
    const qrImg = document.createElement("img");
    qrImg.src = qrCanvas.toDataURL("image/png"); // Convert to base64
    qrImg.style.width = "150px";
    qrImg.style.height = "150px";
    clonedContent.querySelector("canvas")?.replaceWith(qrImg);
  }

  // ✅ Convert All Images to Base64 Before Generating PDF
  const images = clonedContent.getElementsByTagName("img");
  const imageLoadPromises = Array.from(images).map((img) => {
    return new Promise<void>((resolve) => {
      const newImg = document.createElement("img");

      if (img.src.startsWith("data:image")) {
        resolve(); // Already Base64
      } else {
        fetch(img.src)
          .then((res) => res.blob())
          .then((blob) => {
            const reader = new FileReader();
            reader.onload = () => {
              newImg.src = reader.result as string;
              newImg.style.width = img.style.width;
              newImg.style.height = img.style.height;
              img.replaceWith(newImg);
              resolve();
            };
            reader.readAsDataURL(blob);
          })
          .catch(() => resolve()); // Ignore errors and continue
      }
    });
  });

  // ✅ Wait for all images to load before generating the PDF
  Promise.all(imageLoadPromises).then(() => {
    html2pdf()
      .from(clonedContent)
      .save(`PanelEngineerLicense${application?.applicationId}.pdf`);
  });
};

const getCurrentDate = (): string => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

useEffect(()=>{
 fetchLicenseQr();
  
},[qrUrl])

return (
    <>
        <div ref={pdfRef} style={{display: "none", width: "100%", padding: "20px", fontFamily: "NotoSansGujarati, Arial, sans-serif", border:"2px dotted black" }} >
          <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" , marginBottom:"15px", padding: "2px",  width: "100%", }}>
          
          {/* ✅ QR Code */}
          {/* <div >
            <QRCodeCanvas value="https://reactjs.org/" style={{ width: 100, height: 100 }} />
          </div> */}

          {qrUrl && (
              <div className="">
                <img src={qrUrl} alt="QR Code"  style={{ width: '100px', height: '100px' }} />
              </div>
            )}

          {/* ✅ Emblem Image */}
          <img src="//upload.wikimedia.org/wikipedia/commons/thumb/5/55/Emblem_of_India.svg/376px-Emblem_of_India.svg.png" alt="National Emblem" style={{ width: "70px" , height:"100px" }} />

          {/* ✅ Another Image */}
	  <img src="https://st3.depositphotos.com/13159112/17145/v/450/depositphotos_171453724-stock-illustration-default-avatar-profile-icon-grey.jpg" alt="Photo" style={{ height: "100px" }} />
        </div>
      <div style={{ textAlign: "center", marginBottom: "10px" ,   borderBottom: "2px solid black",  paddingBottom: "10px", marginTop:"20px"}}>
        <h4 style={{ color: "blue" }}>નિયામક, ખેતબજાર અને ગ્રામ્ય અર્થતંત્ર, ગુજરાત રાજય, ગાંધીનગર</h4>
        <p style={{ color: "blue" }}>બ્લોક નં. ૧૩/૨, ડો. જીવરાજ મહેતા ભવન, ગાંધીનગર</p>
        <p style={{ marginBottom: "5px" }}>
        Website: <a style={{ color: "blue" , borderBottom: "1px solid black" }} href="agri.gujarat.gov.in">agri.gujarat.gov.in</a> | 
        Tele No: (079) 23254584
        </p>
        Email id: <span style={{ borderBottom: "1px solid black", display: "inline-block", minWidth: "100px" }}>director.apmc2018@gmail.com</span>

      </div>
          </div>
      

      <div style={{ marginTop: "10px" }}>
        <p style={{ display: "flex", justifyContent: "space-between", width: "80%" }}><div><strong>ક્રમ નં.:</strong> નાબસ/૦૧/થ/ઓ.એસ./૨૦૨૫ </div> <strong>તારીખ: {getCurrentDate()}</strong> </p>

        <h4>વંચાણે લીધા:</h4>
        <ul>
          <li>(૧) ગુજરાત ખેત ઉત્પન્ન બજાર બાબતના નિયમો-૧૯૬૫ના નિયમ-૪૪ની જોગવાઇ</li>
          <li>(૨) આ કાર્યાલયના તા.૧૦/૦૩/૨૦૨૫ ના પરિપત્ર ક્રમાંક :- નબસ/૦૧/થ/ઓ.એસ/૧૧૭/૨૦૨૫</li>
          <li>(૩) નાયબ નિયામક અને જિલ્લા રજિસ્ટ્રારશ્રી સહકારી મંડળીઓ, {application?.department?.District} {application?.borderDepartmentIdentifier && application?.departmentSelectType!=="entireState" ? (application?.borderDepartmentIdentifier.length>0 && (application?.borderDepartmentIdentifier.map((data) => data.District).join(" ,"))) : "(Entire State)"} તારીખ <span style={{ borderBottom: "1px solid black", display: "inline-block", minWidth: "100px"}} >{appliedDate(application.appliedDate)}</span> </li>


          <li>પત્ર ક્રમાંક:- <span style={{ borderBottom: "1px solid black", display: "inline-block", minWidth: "60px" }}>
            {application.applicationId || ""}
          </span> થી રજુ થયેલ દરખાસ્ત</li>
        </ul>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <h4 style={{ marginTop: "10px", marginBottom: "5px" }}>-:હુકમ:</h4>
        </div>
        <p style={{  textAlign:"justify",textAlignLast: "justify" }}>
        આમુખ-૧ની જોગવાઇ અનુલક્ષીને ખાતાની માન્ય ઇજનેરીની પેનલની યાદી મંજુર કરવાની જરૂરિયાત જણાતાં, આમુખ-૨ના પરિપત્રની વિગતે દરખાસ્તો મંગાવવામાં આવેલ હતી. જે અન્યવે આમુખ-૩ના પત્રથી મળેલ દરખાસ્ત અન્વયે ચકાસણી કરતાં નિયમોનુસાર લાયકાત અને અનુભવ ધરાવતાં નીચે દર્શાવેલ ઇજનેરને તા. {getCurrentDate()} થી તા31/03/2028 સુધીના સમય માટે આ સાથે સામેલ પરિશિષ્ટ - ‘અ’ માં દર્શાવેલ શરતોને આધિન રહીને {" "}
      {application?.department?.District}  {application?.departmentSelectType !== "singleDistrict"&& ","&&application?.borderDepartmentIdentifier  ?.map((dept) => dept.District).join(", ")} પેનલ યાદીમાં નામ નવુ  કરવાનો આથી હુકમ કરવામાં આવે છે.
 
        </p>
      </div>

      <div style={{ marginTop: "20px", marginBottom:"10px",width: "100%"  }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "10px", border: "1px solid black" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid black", padding: "6px" }}>અ.નં.</th>
              <th style={{ border: "1px solid black", padding: "6px" }}>પેનલ નંબર</th>
              <th style={{ border: "1px solid black", padding: "6px" }}>ઇજનેરશ્રીનું નામ</th>
              <th style={{ border: "1px solid black", padding: "6px" }}>પૂરૂ સરનામુ</th>
              <th style={{ border: "1px solid black", padding: "6px" }}>શૈક્ષણિક લાયકાત</th>
            </tr>
          </thead>
          <tbody style={{ marginTop: "5px", marginBottom:"5px"}}>
            { Object.keys(application).length > 0 ? (
              // application.map((user, index) => (
                <tr>
                  <td style={{ border: "1px solid black", padding: "6px" }}> 1</td>
                  <td style={{ border: "1px solid black", padding: "6px" }}>{application.penalNo || ""}</td>
                  <td style={{ border: "1px solid black", padding: "6px" }}>{application?.applicantName || ""}</td>
                  <td style={{ border: "1px solid black", padding: "6px" }}>
                  {application?.perAddress?.at || ""} Taluka: {application?.perAddress?.taluka || ""} Dist. {application?.perAddress?.district || ""}
                  </td>
                  <td style={{ border: "1px solid black", padding: "6px" }}>{educat}</td>
                </tr>
              // ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center", border: "1px solid black", padding: "6px" }}>
                  કોઈ ડેટા ઉપલબ્ધ નથી
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginBottom: "15px", marginTop:"25px" }}>
        <div>
        <div style={{ textAlign: "center" }}>
          <div>નિયામક</div><br />
        </div>
        <div style={{textAlign:"center"}}>
          ખેતબજાર અને ગ્રામ્ય અર્થતંત્ર<br />
          ગુજરાત રાજય, ગાંધીનગર
        </div>
      </div>
      
      </div>

      <h4 style={{marginBottom:"20px"}}>પ્રતિ:</h4>
      <p>
        નામ: <span style={{ borderBottom: "1px solid black", display: "inline-block", minWidth: "100px" }}>
          {application?.applicantName || ""}
        </span><br />
        સરનામું: <span style={{ borderBottom: "1px solid black", display: "inline-block", minWidth: "100px" }}>
          {officeAddress?.address || ""} Taluka: {officeAddress?.taluka || ""} Dist. {officeAddress?.district || ""}
        </span><br />
        મોબાઇલ નંબર: <span style={{ borderBottom: "1px solid black", display: "inline-block", minWidth: "100px" }}>
          {application?.mobileNo || ""}
        </span><br />
        ઈ-મેલ: <span style={{ borderBottom: "1px solid black", display: "inline-block", minWidth: "100px" }}>
          {application?.regEmailId || ""}
        </span>
      </p>

      <h4>નકલ રવાના :</h4>
      <ul>
        <li>(૧) નાયબ નિયામક, ખેત બજાર અને જિલ્લા રજિસ્ટ્રાર, સહકારી મંડળીઓ, મહીસાગર</li>
        <li>(૨) મેનેજીંગ ડીરેકટરશ્રી, ગુજરાત રાજય કૃષિ બજાર બોર્ડ, ગાંધીનગર</li>
      </ul>

       <div style={{ marginTop: "30px", pageBreakBefore: "always", paddingTop: "20px" , paddingLeft:"10px" }}>
        <h3 style={{ textAlign: "center", marginBottom: "15px", fontSize: "18px" }}>પરિશિષ્ટ-ક</h3>
        
        <p style={{ marginBottom: "15px", fontSize: "16px", textAlign: "center" }}>નીચે મુજબની શરતોને આધીન રહીને પેનલ ઇજનેરો તરીકે કામગીરી કરવાની રહેશે.</p>

        <ol style={{ lineHeight: "2.0", textAlign: "justify", fontSize: "16px", listStyleType: "decimal" }}>
          <li style={{ marginBottom: "15px" }}>જે જિલ્લાની પેનલમાં નામ સમાવવામાં આવેલ હોય તે જ જિલ્લાની બજાર સમિતિમાં કન્સલટીંગ એન્જીનીયર તરીકે કામગીરી કરવાની રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>આ કાર્યાંલયની પેનલ ઉપરની યાદીમાં માન્યતા મેળવતા ઇજનેરોએ બજાર સમિતિના બાંધકામ ના કામોએ બાંધકામના પ્રોજેકટ, પ્લાનીંગ, ડીઝાઈનીંગ, એસ્ટીમેટ તૈયાર કરવાની, ટેન્ડર કામર્સ તૈયાર ક રાવવાની, બાંધકામના સુપરવિઝનની, બાંધકામના સીવીલ કોન્ટ્રાકટરોના કામોના ટેન્ડર ૨જુ થાય અને મંજુર થાય તે સભામાં ફરજીયાત હાજરી આપવાની, બજાર સમિતિના બાંધકામના ૨જુ થયેલા ટેન્ડરોને પૈકી મંજુર કરવા માત્ર સીવીલ કોન્ટ્રાકટરોના ટેન્ડરો મંજુર કરવાનો સ્વયંસ્પષ્ટ અભિપ્રાય આપવાની,સ્પેસીફીકેશન અને મેજરમેન્ટ મુજબ સાઇટ સુપરવિઝન રીપોર્ટે આપવાતીત સીવીલ કોન્ટ્રાકટરના રજુ થતા રનીંગબીલો તથા ફાયનલ બીલોની પુર્તી યોકસાઈ સહર યકાસણી કરી બીલો પ્રમાણીત કરી મુકલવાપાત્ર રકમનો સ્પષ્ટ અભિપ્રાય બીલમાં લખવાની વગેરે તમામ કામગીરી કન્સલટીંગ એન્જીનીયર ધ્વારા જ કરવાની રહેશે.અને ટેકનીકલ અથવા હલકી ગુણવત્તાથી ઉપસ્થિત થતી તમામ જવાબદારીના કિસ્સામાં સમગ્ર ભારે સહિત કન્સલટીંગ એન્જીનીયર પણ જવાબદાર બનશે.</li>
          
          <li style={{ marginBottom: "15px" }}>રાજયના લુક્ફ ઝોન નં.૩,૪,અને ૫ માં આવતી બજાર સમિતિઓના પ્લાન અને બાંધકામ સ્કુકચરલ એન્જીનીયરની સહાયની લુક્ફ પ્રતિચેધક હોય તેવા બનાવવાના રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>બજાર સમિતિ તરફથી પેનલ ઉપરના ઇજનેરની નિમણુંક થાય ત્યારે પ્લાન સંદર્ભમાં સહી/સિકા કરી, માન્યતાનો પેનલ નંબર અચુક જણાવવાનો રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>ઇજનેરશ્રીએ પ્લાન એસ્ટીમેટ સાથે લે-આઉટ પ્લાન ફરજીયાત રજુ કરવાનો રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>ઇજનેરશ્રીએ રજુ કરેલા પ્લાન-એસ્ટીમેટમાં સરકારશ્રીની વિવિધ યોજનાઓમાં જે નામનો ઉલ્લેખ થયેલ હોય તે નામનો જ ઉલ્લેખ કરવાનો રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>પેનલ ઉપરના ઇજનેરે મંજુર થયેલા પ્લાન/ડીઝાઇન મુજબ, ઉચ્ચ ગુણવત્તાવાળા બાંધકામના મટીરીયલ થી બાંધકામમાં માન્ય ધારાધોરણો મુજબનું બાંધકામ થયેલું છે.તેની ચકાસણી કરવાની રહેશે. સદર જણાવેલ કામોના કોઇ પણ અનિયમિતતા જણાય તો બજાર સમિતિ તથા લગત જિલ્લા રજિસ્ટ્રારશ્રીનું ધ્યાન દોરવું.</li>
          
          <li style={{ marginBottom: "15px" }}>બજાર સમિતિ તરફથી હાથ ધરેલ કામોની પ્રગતિની જાતે અગર તેમના નિમ્ણાત તજજ્ઞો મારફતે દર પંદર દિવસે યોજ્ય માં ઓછી મેક વખત અચુક કરવાનું રહેશે.</li>
        </ol>
      </div>

      {/* Page 2 of Terms and Conditions */}
      <div style={{ marginTop: "30px", pageBreakBefore: "always", paddingTop: "20px",paddingLeft:"10px" }}>
        <ol start={9} style={{ lineHeight: "2.0", textAlign: "justify", fontSize: "16px", listStyleType: "decimal" }}>
          <li style={{ marginBottom: "15px" }}>કામની ચકાસણી દરમ્યાન પ્લાન મુજબ કામ થયું ન હોય તો બજાર સમિતિ તથા લગત જિલ્લા રજિસ્ટ્રારશ્રીનું ધ્યાન દોરવું.</li>
          
          <li style={{ marginBottom: "15px" }}>કોન્ટ્રાકટર પાસેથી કામનું રનીંગ બીલ મળેથી તેની માપણી કરી બજાર સમિતિને પ્રમાણપત્ર આ પહું.તે બાદ જ પેમેન્ટ કરવાનું ધોરણ રાખવું. ઉચ્યક પેમેન્ટ ચુકવવા મંજુરી ન આપવી.</li>
          
          <li style={{ marginBottom: "15px" }}>જે કામ પુર્ણ થયેલુ હોય તેની સંપુર્ણ ચકાસણી બાદ જ કમ્પ્લીશન સર્ટીફીકેટ આપવું.</li>
          
          <li style={{ marginBottom: "15px" }}>બાંધકામ સમયમર્યાદામાં પુર્ણ થાય તે માટે કોન્ટ્રાકટર સાથે જરૂરી સંકલનમાં રહેવાનું રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>જો નિયંત્ર પ્લાન સંદાજ મુજબ કામ ન થયેલ હોય અને ઇજનેરશ્રી પ્રમાણ પત્ર આપશે તો તે માટે તે મની અંગત જવાબદારી રહેશે.અને માન્યતા રદ કરવાને પાત્ર રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>બાંધકામમાં થયેલા અનિયમિતતા ભાળવતની તપાસ સંદર્ભ નિયામકશ્રી દ્વારા જે માહિતી માંગવામાં આવે તે કોઇ પણ પ્રકારની વહારની કી ચુકવ્યા સિવાય પુરી પાડવાની રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>માન્ય પેનલ ઉપરની ઇજનેરે યાદી હેઠળ નોંધાયેલા ઇજનેરે બજાર સમિતિના સીવીલ કોન્ટ્રાકટરના કામો મેળવતા સીવીલ કોન્ટ્રાકટરોની પેઢીમાં સીધી લીટીના કે પોતાના કુટુંબીજનોના નામે ભાગીદાર તરીકે જોડાયેલા ન હોવા જોઇએ અને તેનું ચુસ્તપણે પાલન કરવાનું રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>રાષ્ટ્રીયકૃત ગૃડ ગોડાઉન કે સરકારી વિસ્તાર ગોડાઉન યોજના હેઠળનું કામ સોપવામાં આવે તો એસ.ઓ.આર.મુજબ તે અદાજ તૈયાર કરવા તેથી વધુ ખર્ચે થતો હોય તો કારણો આપવા વપરાશનું પ્રમાણપત્ર તાત્કાલિક આપવું તથા કામ પુરું થયાનું પ્રમાણપત્ર કામ પુરૂ થયેથી તરત આપવું.</li>
          
          <li style={{ marginBottom: "15px" }}>ઉપરોકત શરતો પૈકી કોઇ શરતોનો ભંગ થયેલ જણાશે તો માન્યતા રદ કરવાને પાત્ર રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>આ શરતોમાં નિયામકશ્રીને યોજ્ય જણાય તો વખતો વખત સુધારો વધારો કરી શકશે.</li>
          
          <li style={{ marginBottom: "15px" }}>ટેકનીકલ અથવા હલકી ગુણવત્તાથી ઉપસ્થિત થતી તમામ જવાબદારીના કિસ્સામાં સમગ્ર ભારે સહિત કન્સલટીંગ એન્જીનીયર પણ જવાબદાર બનશે.</li>
          
          <li style={{ marginBottom: "15px" }}>રાજયની કોઇપણ બજાર સમિતિમાં બાંધકામના કામો સુચિત બાંધકામ કેમ, સ્કુકચરલ વર્કવાળુ હોય તેવા કિસ્સામાં બજાર સમિતિના કન્સલટીંગ એન્જીનીયર સ્કુકચરલ એન્જીનીયરની વિશેષ લાયકાત ધરાવતા હોવા ફરજીયાત રહેશે.</li>
          
          <li style={{ marginBottom: "15px" }}>પેનલ પર દાખલ થયેલ એન્જીનીયરોએ દર ત્રણ માસે અત્રેની કચેરીને કામગીરી રીપોર્ટ નીચેના ફોર્મેટમાં મોકલવાનો રહેશે.</li>
        </ol>

        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "80px", marginBottom: "15px", border: "1px solid black", fontSize: "16px" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid black", padding: "6px" }}>ક્રમ</th>
              <th style={{ border: "1px solid black", padding: "6px" }}>જિલ્લાનું નામ</th>
              <th style={{ border: "1px solid black", padding: "6px" }}>બજાર સમિતિનું નામ</th>
              <th style={{ border: "1px solid black", padding: "6px" }}>કામગીરીનો હેતુ</th>
              <th style={{ border: "1px solid black", padding: "6px" }}>પ્રોજેક્ટ કોસ્ટ (લાખમાં)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: "1px solid black", padding: "6px", height: "30px" }}>&nbsp;</td>
              <td style={{ border: "1px solid black", padding: "6px" }}>&nbsp;</td>
              <td style={{ border: "1px solid black", padding: "6px" }}>&nbsp;</td>
              <td style={{ border: "1px solid black", padding: "6px" }}>&nbsp;</td>
              <td style={{ border: "1px solid black", padding: "6px" }}>&nbsp;</td>
            </tr>
          </tbody>
        </table>
        
        <ol start={22} style={{ marginTop: "30px", pageBreakBefore: "always", paddingTop: "20px", lineHeight: "1.8", textAlign: "justify", fontSize: "16px", listStyleType: "decimal" }}>
          <li style={{ marginBottom: "15px" }}>જો કોઇપણ અન્ય સરકારી સંસ્થા/એજન્સી દ્વારા આપને/આપની ફર્મ એજન્સીને બ્લેકલીસ્ટ કરવામાં આવે તો તુરંત અત્રેની કચેરીને જાણ કરવાની રહેશે. તેમજ ત્યારબાદ કોઇપણ બજાર સમિતિમાં પેનલ એન્જીનીયરને લગત કામગીરી કરી શકશે નહી.</li>
          
          <li style={{ marginBottom: "15px" }}>તા.૧૦/૦૩/૨૦૨૫ પરિપત્ર ક્રમાંક: નબસ/૦૧/થ/ઓ.એસ/૧૧૭/૨૦૨૫ ની તમામ શરતોનું પાલન કરવાનું રહેશે.</li>
        </ol>
      </div>

    </div>

        <div className="text-center">
    <button
      className="bg-success rounded text-white px-4 py-2 flex items-center gap-2"
      onClick={handleDownloadPDF}
      disabled={loading} // Disable button while loading
    >
      {loading ? (
        <>
          <i className="fa fa-spinner fa-spin"></i> Downloading...
        </>
      ) : (
        "1. Download License"
      )}
    </button>
   
    </div>
    </>
  


  );
};

export default PanelLicenseDownload;
